<template>
  <div id="reg-watch-description-modal" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content p-20">
        <div class="col-xs-12 p-0 mb-20">
          <div class="top-header col-xs-10 p-0" v-html="regWatch.title"></div>
          <div class="col-xs-2 text-right p-0">
            <img
              src="/static/images/icons/close_icon.svg"
              alt
              class="cursor-pointer"
              data-dismiss="modal"
            />
          </div>
        </div>
        <div class="modal-body p-10" v-html="regWatch.longDescription"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['regWatch'],
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.modal-header,
.modal-footer {
  border: 0;
  background: #ffffff;
}
.modal-body {
  max-height: 60vh;
  overflow-y: auto;
  scrollbar-width: thin;
}
.top-header {
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
  word-break: break-word;
}
</style>
